module.exports = __webpack_public_path__ + "img/Aria_remove_existing_poster.1427a5fc.png";